import * as React from "react";
import { CurrencyContext } from "./currency-context";
import type { CurrencyContextValue } from "./types";

export function useCurrency(): CurrencyContextValue {
  const context = React.useContext(CurrencyContext);
  if (!context) {
    throw new Error("useCurrency must be used within a CurrencyProvider");
  }
  return context;
}

export function useCurrencyOptional(): CurrencyContextValue | null {
  return React.useContext(CurrencyContext);
}
